import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function FooterBox() {
  const goTop = () => {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  };
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <footer className='relative bg-[#F8F9FA] flex flex-col justify-start items-start'>
      <div className='w-full border-b-[1px] border-[#E5E5EC] py-[12px]'>
        <div className='w-full max-w-[1540px] mx-auto flex justify-between items-center gap-[10px] px-[1%] md:flex-wrap'>
          <nav className='w-full flex-1'>
            <ul className='w-full text-[#222222] text-[14px] leading-[20px] whitespace-pre-line break-keep flex justify-start items-center gap-[24px]'>
              <Link
                to='https://kodeal.fks.co.kr/about'
                target='_blank'
                className='cursor-pointer'
              >
                협회소개
              </Link>
              <Link
                to='https://kodeal.fks.co.kr/guide?tab=5'
                target='_blank'
                className="cursor-pointer pl-[24px] relative after:content-[''] after:w-[1px] after:h-[10px] after:absolute after:left-0 after:top-0 after:bottom-0 after:my-auto after:bg-[#E5E5EC]"
              >
                개인정보처리방침
              </Link>
              <Link
                to='https://kodeal.fks.co.kr/guide'
                target='_blank'
                className="cursor-pointer pl-[24px] relative after:content-[''] after:w-[1px] after:h-[10px] after:absolute after:left-0 after:top-0 after:bottom-0 after:my-auto after:bg-[#E5E5EC]"
              >
                이용약관
              </Link>
              <Link
                to='https://kodeal.fks.co.kr/customer'
                target='_blank'
                className="cursor-pointer pl-[24px] relative after:content-[''] after:w-[1px] after:h-[10px] after:absolute after:left-0 after:top-0 after:bottom-0 after:my-auto after:bg-[#E5E5EC]"
              >
                제휴문의
              </Link>
              {/* 
                <Link
                  to='https://kodeal.fks.co.kr/customer'
                  target='_blank'
                  className="cursor-pointer pl-[24px] relative after:content-[''] after:w-[1px] after:h-[10px] after:absolute after:left-0 after:top-0 after:bottom-0 after:my-auto after:bg-[#E5E5EC]"
                >
                  대량판매
                </Link> 
              */}
            </ul>
          </nav>
          <div className='shrink-0 text-white flex justify-start items-center gap-[6px] md:ml-auto'>
            <p className='text-[13px] font-[500] mr-[12px] text-[#555555]'>
              한국영업경제인협회 앱 다운로드
            </p>
            <button
              onClick={() => {
                window.open(
                  'https://play.google.com/store/apps/details?id=com.carsayo.fks',
                );
              }}
              className='flex justify-center items-center gap-[6px] py-[10px] px-[8px] bg-white border border-[#E5E5EC] text-[#111111] rounded-[6px]'
            >
              <img
                src='/imgs/icons/google.webp'
                alt='플레이스토어 아이콘'
                className='w-[16px] object-contain'
              />
              <span className='text-[12px] '>Play Store</span>
            </button>
            <button
              onClick={() => {
                window.open(
                  'https://apps.apple.com/us/app/%ED%95%9C%EA%B5%AD%EC%98%81%EC%97%85%EA%B2%BD%EC%A0%9C[…]B4%EC%BB%A4%EB%A8%B8%EC%8A%A4-%ED%8F%AC%ED%84%B8/id6737255285',
                );
              }}
              className='flex justify-center items-center gap-[6px] py-[10px] px-[8px] bg-white border border-[#E5E5EC] text-[#111111] rounded-[6px]'
            >
              <img
                src='/imgs/icons/apple_logo.png'
                alt='애플스토어 아이콘'
                className='w-[16px] object-contain'
              />
              <span className='text-[12px] '>App Store</span>
            </button>
          </div>
        </div>
      </div>
      <div className='w-full flex flex-col text-[#222222] justify-start items-start py-[30px]'>
        <div className='w-full max-w-[1540px] mx-auto flex justify-between gap-[20px] items-center px-[1%] mb-[20px]'>
          <div>
            <h1
              className='h-[30px] mb-[30px] cursor-pointer'
              onClick={() => {
                window.location.reload();
                window.scrollTo({ top: 0 });
              }}
            >
              <img
                src='/imgs/icons/logo_footer.png'
                alt='한국영업경제인협회 로고'
                className='h-full object-contain '
              />
            </h1>
            <div className='w-full flex flex-col justify-start items-start gap-[12px] leading-[100%]'>
              <p>
                <span className="relative pr-[6px] mr-[6px] after:content-[''] after:w-[1px] after:h-[10px] after:absolute after:right-0 after:top-0 after:bottom-0 after:my-auto after:bg-white">
                  대표자 : 최용민
                </span>
                <span>사업자 등록번호 : 214-82-79500</span>
              </p>
              <address className='not-italic whitespace-pre-line break-keep'>
                주소 : (04790) 서울특별시 성동구 아차산로 49, 1404호
              </address>
              <p>통신판매업신고 : 제 2024-서울성동-1541호</p>
              <p>
                {/* <span className="relative pr-[6px] mr-[6px] after:content-[''] after:w-[1px] after:h-[10px] after:absolute after:right-0 after:top-0 after:bottom-0 after:my-auto after:bg-white">
                  개인정보보호책임자 : 김영진
                </span> */}
                <span>이메일 : info@fks.co.kr</span>
              </p>
              <Link
                to='https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2148279500'
                target='_blank'
                className='underline t ext-[#EDF0F7]'
              >
                사업자 정보확인
              </Link>
            </div>
          </div>
          <div className='w-[458px] p-[18px] bg-[#F2F4F6] rounded-[6px] shrink-0'>
            <p className='text-right font-[600] text-[#9EA3B0] mb-[15px]'>
              FKS.CO.KR
            </p>
            <div className='w-full'>
              <div className='flex justify-start items-center gap-[8px] mb-[20px]'>
                <span className='text-[22px] leading-[22px] font-[600]'>
                  1666-9295
                </span>
              </div>
              <div className='flex flex-col justify-start items-start gap-[12px] leading-[100%]'>
                <p className='flex justify-start items-center'>
                  <span className='w-[64px]'>평일</span>
                  <strong className='font-[500] text-[#222222]'>
                    10:00~18:00
                  </strong>
                </p>
                <p className='flex justify-start items-center'>
                  <span className='w-[64px]'>점심시간</span>
                  <strong className='font-[500] text-[#222222]'>
                    13:00~14:00
                  </strong>
                </p>
                <p className='flex justify-start items-center'>
                  <span className='w-[64px]'>휴무</span>
                  <strong className='font-[500] text-[#222222]'>
                    주말 및 공휴일
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className='w-full max-w-[1540px] mx-auto px-[1%]'>
          <div className='w-full flex justify-between  gap-[20px] items-end'>
            <div className='w-full'>
              <p className='text-[#555555] tracking-[-0.025em]'>
                Copyright ⓒ 한국영업경제인협회 DESIGNER ALL RIGHTS RESERVED.
              </p>
            </div>
            <div className='w-[458px] shrink-0'>
              <span className='font-[500] text-[#9EA3B0]'>Group Company</span>
              <div className='w-full flex justify-start items-center gap-[4px] mt-[14px]'>
                <div className='w-[calc(50%-2px)] p-[18px] bg-[#F2F4F6] rounded-[6px]'>
                  <div className='w-full flex justify-end items-center mg-[18px]'>
                    <img
                      src='/imgs/icons/footer-symbol01.webp'
                      alt='대한영업경제인협회'
                      className='h-[24px] object-contain'
                    />
                  </div>
                  <div className='w-full flex flex-col justify-start items-start gap-[4px] leading-[100%]'>
                    <span>대한영업경제인협회</span>
                    <strong className='text-[12px] font-[500] text-[#C81042]'>
                      ksbiz.or.kr
                    </strong>
                  </div>
                </div>
                <div className='w-[calc(50%-2px)] p-[18px] bg-[#F2F4F6] rounded-[6px]'>
                  <div className='w-full flex justify-end items-center mg-[18px]'>
                    <img
                      src='/imgs/icons/footer-symbol02.webp'
                      alt='전국영업경제인협회'
                      className='h-[24px] object-contain'
                    />
                  </div>
                  <div className='w-full flex flex-col justify-start items-start gap-[4px] leading-[100%]'>
                    <span>전국영업경제인협회</span>
                    <strong className='text-[12px] font-[500] text-[#019CD0]'>
                      fksb.or.kr
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showButton && (
        <AnimatePresence mode='wait'>
          <motion.div
            variants={{
              hidden: { opacity: 0 },
              show: {
                opacity: 1,
                transition: {
                  staggerChildren: 0.2,
                },
              },
            }}
            initial='hidden'
            animate='show'
            exit='hidden'
          >
            <button
              className='z-30 w-[80px] h-[80px] fixed bottom-[20px] right-[20px] bg-up-arrow bg-no-repeat bg-center bg-contain '
              onClick={() => goTop()}
            ></button>
          </motion.div>
        </AnimatePresence>
      )}
    </footer>
  );
}
